import * as React from "react";
import { message } from "antd";
import Dialog from "../dialog";
import NormalComponent from "./component/normal";
import ResultComponent from "./component/result";
import "./style/index.scss";

// import VoteSelectComponent from './component/voteSelect'
// import NormalComponent from './component/status/normal'
// import HintComponent from './component/status/hint'

const voteType = {
  DELETED: "本次投票已删除",
  EXPIRED: "本次投票已经失效"
};

let diating: any;

const hideVoteDialog = () => {
  console.log("hideVoteDialog");
  if (!!diating) {
    diating.hide();
  }
};
const vote = (type: string, result?: any, confirm?: (target: any, param?: any) => void) => {
  if (!!diating) {
    diating.hide();
  }

  const defaultOption = {
    width: "480px",
    cancelText: "取消",
    okText: "确认",
    footer: true,
    onOK: () => {
      console.log("onOK hide");
      diating.hide();
    }
  };

  let margeOption: any;
  if (typeof result === "object" && result.status === "VOTE_REPEAT") {
    message.info("重复投票");
    return;
  }

  switch (type) {
    case "Select": {
      const param: any = {
        content: null,
        okText: "投票"
      };
      if (result.status === "NORMAL") {
        param.content = (
          <NormalComponent
            questions={result.questions}
            id={result.id}
            target={diating}
            hideVoteDialog={hideVoteDialog}
            confirm={confirm}
          />
        );
        param.footer = false;
      } else {
        param.content = <div>{voteType[result.status]}</div>;
        (param.className = "vote__hide-cancel"), (param.okText = "确认");
        param.footer = true;
      }

      margeOption = Object.assign(defaultOption, {
        title: "投票",
        ...param
      });
      break;
    }

    case "Result": {
      margeOption = Object.assign(defaultOption, {
        title: "结果",
        className: "vote__hide-cancel",
        content: <ResultComponent qs={result} />
      });
      break;
    }

    case "Hint": {
      margeOption = Object.assign(defaultOption, {
        title: "提醒",
        content: (
          <div>
            <div className="vote__compere">主持人发起一个投票：</div>
            <div>{result.voteTitle}</div>
          </div>
        ),
        okText: "投票",
        cancelText: "关闭",
        onOK: () => {
          // @ts-ignore
          confirm(diating, result.voteId);
        }
      });
      break;
    }

    case "Repetition": {
      margeOption = Object.assign(defaultOption, {
        title: "提醒",
        className: "vote__hide-cancel",
        content: <div>你已投票</div>
      });
      break;
    }
    case "Reminder": {
      margeOption = Object.assign(defaultOption, {
        className: "vote__hide-cancel",
        title: "提醒",
        content: <div>{voteType[result.status]}</div>
      });
      break;
    }
  }

  diating = new Dialog(margeOption);
};

export default {
  voteSelect(data: any, confirm: any) {
    console.log("1");
    return vote("Select", data, confirm);
  },
  voteHint(param: { voteId: string; voteTitle: string }, confirm: any) {
    console.log("2");

    return vote("Hint", param, confirm);
  },
  voteResult(param: any) {
    console.log("3");

    return vote("Result", param);
  },
  voteRepetition() {
    console.log("4");

    return vote("Repetition");
  },
  voteReminder(data: any) {
    console.log("5");

    return vote("Reminder", data);
  },
  hideDialog() {
    console.log("6");

    hideVoteDialog();
  }
};



// WEBPACK FOOTER //
// ./src/pc/component/vote/index.tsx